import { render, staticRenderFns } from "./NoPower.vue?vue&type=template&id=00558735&scoped=true"
import script from "./NoPower.vue?vue&type=script&lang=js"
export * from "./NoPower.vue?vue&type=script&lang=js"
import style0 from "./NoPower.vue?vue&type=style&index=0&id=00558735&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00558735",
  null
  
)

export default component.exports